import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { GetSilosResponse, LocationSilo } from '@next/core-lib/cart';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import { GetLocationSilosWithProductListResponse, SiloProductItemRequest, SiloProductItemResponse } from '../components/silos/models/silo-product-list.models';

@Injectable({
  providedIn: 'root',
})
export class SiloApiService {
  protected baseUrl = `${this.env.APIM_BASE_URL}/silo-v2-service`;

  constructor(
    protected http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  public deleteSilo(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/silo/${id}`);
  }

  public upsertSilo(silo: LocationSilo): Observable<LocationSilo> {
    return this.http.put<LocationSilo>(`${this.baseUrl}/silo`, silo);
  }

  public getSilos(): Observable<GetSilosResponse> {
    return this.http.get<GetSilosResponse>(`${this.baseUrl}/silo`);
  }

  public getProductListSilos(): Observable<GetLocationSilosWithProductListResponse> {
    return this.http.get<GetLocationSilosWithProductListResponse>(`${this.baseUrl}/silo-product-list`);
  }

  public addProductListItem(productlistItem: SiloProductItemRequest): Observable<SiloProductItemResponse[]> {
    return this.http.post<SiloProductItemResponse[]>(`${this.baseUrl}/silo-product-list`, productlistItem);
  }

  public deleteProductListItem(siloId: number, productListItemId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/silo-product-list/${siloId}/product/${productListItemId}`);
  }
}
